import common from './zh-CN/common';
import charAndTableComponent from './zh-CN/charAndTableComponent';
import dataManagement from './zh-CN/dataManagement';
import dataSourceComponent from './zh-CN/dataSourceComponent';
import extraction from './zh-CN/extraction';
import multidimensional from './zh-CN/multidimensional';
import myAnalysis from './zh-CN/myAnalysis';
import numberPackage from './zh-CN/numberPackage';
import sortableDragComponent from './zh-CN/sortableDragComponent';
import uploadFileComponent from './zh-CN/uploadFileComponent';
import noDataComponent from './zh-CN/noDataComponent';
import exploration from './zh-CN/exploration';
import gptChat from './zh-CN/gptChat';
import createDashboard from './zh-CN/createDashboard';
import dashboardList from './zh-CN/dashboardList';
import menu from './zh-CN/menu';
import sqlAddSource from './zh-CN/sqlAddSource';
import home from './zh-CN/home';
import virtualTable from './zh-CN/virtualTable';
import date from './zh-CN/date';
import sqlView from './zh-CN/sqlView';
import modelManagement from './zh-CN/modelManagement';
import game from './zh-CN/game';
import error from './zh-CN/error';
import personalData from './zh-CN/personalData';
import userFilter from './zh-CN/userFilter';
import abExperiment from './zh-CN/abExperiment';
import aiAnalysis from './zh-CN/aiAnalysis';

export default {
  ...common,
  ...charAndTableComponent,
  ...dataManagement,
  ...dataSourceComponent,
  ...extraction,
  ...multidimensional,
  ...myAnalysis,
  ...numberPackage,
  ...sortableDragComponent,
  ...uploadFileComponent,
  ...noDataComponent,
  ...exploration,
  ...gptChat,
  ...createDashboard,
  ...dashboardList,
  ...menu,
  ...sqlAddSource,
  ...home,
  ...virtualTable,
  ...date,
  ...sqlView,
  ...modelManagement,
  ...game,
  ...error,
  ...personalData,
  ...userFilter,
  ...abExperiment,
  ...aiAnalysis,
};
